import { dsClass } from '../../common/constants/dsClasses';
import { isMultiBiz } from '../../common/utils/accountUtils';
import { useAuth } from '../../public/site/AuthProvider';
import { CompanySelectorWithHeaderText } from '../CompanySelector/CompanySelectorWithHeaderText';
import { Grid } from '../Grid/Grid.js';
import { CardSelectionHeader } from './CardSelectionHeader';
import { ProductOfferingsCardsByOfferTypeCoCo } from './ProductOfferingsCardsByOfferTypeCoCo';
import type { OfferType } from '../../common/enums';

interface OrderProductOfferingsSelectionCoCoProps {
  offerType: OfferType;
}

export const OrderProductOfferingsSelectionCoCo = ({ offerType }: OrderProductOfferingsSelectionCoCoProps) => {
  const { authenticatedUser } = useAuth();
  const showCompanySelector = isMultiBiz(authenticatedUser);

  return (
    <section aria-label="Product offerings selection" className="of-order-subscription-selection">
      <Grid>
        <div className={`of-product-selector-container ${dsClass.MARGIN_TOP_6} ${dsClass.PADDING_BOTTOM_7}`}>
          <CardSelectionHeader onlineModelType={offerType} />
          {showCompanySelector && (
            <div
              className={`of-order-subscription-selection__company-selector ${dsClass.MARGIN_TOP_4} ${dsClass.MARGIN_BOTTOM_6}`}
            >
              <CompanySelectorWithHeaderText />
            </div>
          )}
          <ProductOfferingsCardsByOfferTypeCoCo offerType={offerType} publicPages={false} />
        </div>
      </Grid>
    </section>
  );
};
